import { useEffect } from 'react';
import classnames from 'classnames';
import { Icon } from '@sparrow-marketing/storybook';
import { CSSTransition } from 'react-transition-group';

import ApplicationContainer from '../../providers/application';

import NotificationBarPortal from './notification-bar-portal';
import './notificationbar.css';

const mapTypeToIcon = {
  error: 'danger',
  success: 'round-checkmark',
  warning: 'info',
  info: 'info',
};

const NotificationBar = ({ className = '' }) => {
  const {
    state: applicationState,
    clearNotification,
  } = ApplicationContainer.useContainer();

  const { notification } = applicationState;
  const notificationClasses = classnames(
    'NotificationBar',
    {
      [`NotificationBar--${notification.type}`]: notification.type,
      'NotificationBar--isOpen': notification.isOpen,
    },
    className
  );
  useEffect(() => {
    let timeout = null;
    if (notification.isOpen && notification.timeout) {
      timeout = setTimeout(() => {
        clearNotification();
      }, notification.timeout);
    }
    return function removeTimeout() {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [clearNotification, notification]);

  const renderNotification = NotificationComponent => {
    if (NotificationComponent) {
      if (typeof NotificationComponent === 'string') {
        return <div>{NotificationComponent}</div>;
      }
      return <NotificationComponent />;
    }
    return null;
  };

  const iconVariant =
    notification.icon || mapTypeToIcon[notification.type] || 'info';

  if (!notification.isOpen) {
    return null;
  }

  return (
    <NotificationBarPortal>
      {/* <CSSTransition
        in={notification.isOpen}
        timeout={500}
        classNames="NotificationBar__wrapper"
        unmountOnExit
      > */}
      <div className={notificationClasses}>
        <div className="NotificationBar__icon-wrapper">
          <Icon
            variant={iconVariant}
            style={{ color: notification.iconColor }}
            className="NotificationBar__icon"
          />
        </div>
        {renderNotification(notification.messageComponent)}
        <Icon
          variant="close"
          onClick={clearNotification}
          className="NotificationBar__close"
        />
      </div>
      {/* </CSSTransition> */}
    </NotificationBarPortal>
  );
};

export default NotificationBar;
